import { MONTHS_SHORT_NAMES } from "../../../../../constants/dates";
import {
  IGetSimulationsData,
  SearchSimulationsPerYearAndMonth,
} from "../../../../../services/ClientsDashboardServices.dto";
import { ChartData, ChartItem, MonthlySimulationWithYear, Row } from "../../clients-dashboard-types";

const sortYears = (data: IGetSimulationsData) => {
  const sortedYears = data.searchSimulationsPerYearAndMonth.sort(
    (a, b) => parseInt(a.year) - parseInt(b.year)
  );
  return sortedYears;
};

const sortMonths = (year: SearchSimulationsPerYearAndMonth) => {
  return year.monthlySimulations.sort((a, b) => parseInt(a.month) - parseInt(b.month));
};

const getMonthsArray = (years: SearchSimulationsPerYearAndMonth[]) => {
  const monthsArray = years.reduce(
    (acc: MonthlySimulationWithYear[], year: SearchSimulationsPerYearAndMonth) => {
      // se añade el dato del año a cada mes para utilizar su label en el eje
      const sortedMonths = sortMonths(year).map((month) => {
        return { ...month, year: year.year };
      });
      return [...acc, ...sortedMonths];
    },
    []
  );
  return monthsArray;
};

export const getSimulationsChartData = (data: IGetSimulationsData): ChartData => {
  const newData: ChartData = [];

  const sortedYears = sortYears(data);
  const monthsArray = getMonthsArray(sortedYears);

  monthsArray.forEach((month) => {
    const newDataItem: ChartItem = {
      month: MONTHS_SHORT_NAMES[month.month],
      year: month.year,
    };
    month.simulationsPerBusinessLine.forEach((product) => {
      newDataItem[product.businessLine] = product.simulationsCount;
    });
    newData.push(newDataItem);
  });

  return newData;
};

export const getTableData = (data: IGetSimulationsData) => {
  const headRow: Row = { className: "", cells: [{ className: "fix-column", value: "Periodo " }] };
  const bodyRows: Row[] = [];
  const footerRow: Row = {
    className: "",
    cells: [{ className: "fix-column", value: "Total general" }],
  };

  data.overallSimulationsResults.simulationsPerBusinessLine.forEach((product) => {
    headRow.cells.push({ className: "", value: `Suma de Simulaciones ${product.businessLine}` });
    footerRow.cells.push({ className: "number", value: product.simulationsCount });
  });
  headRow.cells.push({ className: "", value: "Suma de Total Simulaciones" });
  footerRow.cells.push({
    className: "number",
    value: data.overallSimulationsResults.totalSimulations,
  });

  const sortedYears = sortYears(data);

  sortedYears.forEach((year) => {
    const yearRow: Row = {
      className: "year",
      cells: [{ className: "fix-column", value: year.year, contractActionList: [`${year.year}`] }],
    };
    year.yearlySimulations.simulationsPerBusinessLine.forEach((item) => {
      const newCell = { className: "number", value: item.simulationsCount };
      yearRow.cells.push(newCell);
    });
    yearRow.cells.push({ className: "number", value: year.yearlySimulations.yearTotalCount });
    bodyRows.push(yearRow);

    const monthsRows: Row[] = [];
    sortMonths(year).forEach((month) => {
      const monthRow: Row = {
        className: "month",
        cells: [{ className: "fix-column", value: MONTHS_SHORT_NAMES[month.month] }],
        contractByList: [`${year.year}`],
      };
      month.simulationsPerBusinessLine.forEach((item) => {
        const newCell = { className: "number", value: item.simulationsCount };
        monthRow.cells.push(newCell);
      });
      monthRow.cells.push({ className: "number", value: month.monthTotalCount });
      monthsRows.push(monthRow);
    });
    bodyRows.push(...monthsRows);
  });

  return {
    headRow,
    bodyRows,
    footerRow,
  };
};
